export default {"src":"/_next/static/media/e-commerce-platform.d4f36a4b.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};